import { Box } from "@mui/material";
import Markdown from "react-markdown";
import { unsupportedMarkdownConstructs } from "../utils/markdown";

// MarkdownEditor, which writes this text, turns the same constructs off in its parser, and the
// viewer has to read the text the way the editor does - see unsupportedMarkdownConstructs
function plainTextForUnsupportedSyntax() {
  const data = this.data();
  data.micromarkExtensions = [
    ...(data.micromarkExtensions ?? []),
    { disable: { null: unsupportedMarkdownConstructs } },
  ];
}

/**
 * Renders the markdown written in MarkdownEditor: headings, bold and italic, lists, quotes and
 * thematic breaks. HTML, links and images are never rendered as markup, only shown as text.
 *
 * @param {object} props
 * @param {string} [props.markdown] The content to render.
 * @param {object} [props.sx] MUI sx overrides for the surrounding box.
 */
const MarkdownViewer = ({ markdown, sx }) => (
  <Box
    sx={{
      overflowWrap: "break-word",
      "& > :first-child": { marginTop: 0 },
      "& > :last-child": { marginBottom: 0 },
      "& p, & ul, & ol, & blockquote": { margin: "0 0 8px 0" },
      "& h1, & h2, & h3": { margin: "16px 0 8px 0", lineHeight: 1.3 },
      "& h1": { fontSize: "1.5rem" },
      "& h2": { fontSize: "1.25rem" },
      "& h3": { fontSize: "1.1rem" },
      "& ul, & ol": { paddingLeft: "24px" },
      "& blockquote": {
        paddingLeft: "12px",
        borderLeft: (theme) => `3px solid ${theme.palette.grey[400]}`,
        color: (theme) => theme.palette.text.secondary,
      },
      "& hr": {
        border: "none",
        borderTop: (theme) => `1px solid ${theme.palette.grey[400]}`,
        margin: "16px 0",
      },
      ...sx,
    }}
  >
    <Markdown remarkPlugins={[plainTextForUnsupportedSyntax]}>{markdown ?? ""}</Markdown>
  </Box>
);

export default MarkdownViewer;
